export enum CastCharacterMeasureMapping {
    waist = 'waist',
    bust_or_chest = 'chest',
    shoulder_circumference = 'shoulders',
    height_in = 'height',
    hips_at_seat = 'hips',
    cb_neck_to_wrist_not_bent = 'cb_neck_to_wrist_not_bent',
    bicep_not_flexed_1 = 'bicep_not_flexed',
    cb_neck_to_waist = 'cb_to_waist',
    cb_neck_to_floor = 'cb_neck_to_floor',
    thigh = 'thigh',
    half_girth = 'half_girth',
    full_girth = 'full_girth',
    r_shoe_size = 'shoe',
    shoulder_to_wrist_right = 'shoulder_to_wrist',
    hand_length = 'hand_length',
    neck_length = 'neck_length'
}
